import { render } from "./nestedParts.vue?vue&type=template&id=37b40927"
import script from "./nestedParts.vue?vue&type=script&lang=js"
export * from "./nestedParts.vue?vue&type=script&lang=js"

import "./nestedParts.vue?vue&type=style&index=0&id=37b40927&lang=css"

import exportComponent from "/home/collin/workspace/hitech05/main-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__